export default __webpack_public_path__ + "static/media/Campfire_Loop.95271675.wav";